export default import.meta.ROLLDOWN_FILE_URL_BHtXAtlE7bokZjR_HOSUDA